import { render, staticRenderFns } from "./VExpandableList.vue?vue&type=template&id=7bf5c87f"
import script from "./VExpandableList.vue?vue&type=script&lang=js"
export * from "./VExpandableList.vue?vue&type=script&lang=js"
import style0 from "./VExpandableList.vue?vue&type=style&index=0&id=7bf5c87f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf5c87f')) {
      api.createRecord('7bf5c87f', component.options)
    } else {
      api.reload('7bf5c87f', component.options)
    }
    module.hot.accept("./VExpandableList.vue?vue&type=template&id=7bf5c87f", function () {
      api.rerender('7bf5c87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/common/VExpandableList.vue"
export default component.exports